import React from 'react'
import cls from './myCheckBox.module.scss'

const MyCheckBox = props => {
  return <input {...props} className={cls.checkbox} type={'checkbox'}></input>
}

export default MyCheckBox
